import React from 'react';
import { Mail, MapPin, Instagram } from 'lucide-react';
import { WaveDivider } from './WaveDivider';
export function Footer() {
  return <footer className="bg-primary-dark text-white relative pt-20" data-id="element-31">
      <WaveDivider position="top" color="#3A7A8C" className="absolute top-0 left-0 right-0 -mt-1" data-id="element-32" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 pb-12 pt-12" data-id="element-33">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-34">
          <div className="space-y-4" data-id="element-35">
            <h3 className="font-heading text-2xl font-bold" data-id="element-36">Coastal Ember</h3>
            <p className="text-white/80 max-w-xs" data-id="element-37">
              Taxes, but easier. Professional preparation for the modern world.
            </p>
          </div>

          <div className="space-y-4" data-id="element-38">
            <h4 className="font-bold text-lg" data-id="element-39">Contact</h4>
            <ul className="space-y-3" data-id="element-40">
              <li className="flex items-center text-white/80 hover:text-white transition-colors" data-id="element-41">
                <Mail className="w-5 h-5 mr-3" data-id="element-42" />
                <a href="mailto:info@emberquestsolutions.com" data-id="element-43">
                  info@emberquestsolutions.com
                </a>
              </li>
              <li className="flex items-center text-white/80" data-id="element-44">
                <MapPin className="w-5 h-5 mr-3" data-id="element-45" />
                <span data-id="element-46">Southern California</span>
              </li>
            </ul>
          </div>

          <div className="space-y-4" data-id="element-47">
            <h4 className="font-bold text-lg" data-id="element-48">Service Area</h4>
            <p className="text-white/80" data-id="element-49">
              Serving clients throughout Southern California and beyond. Remote
              filing available for all 50 states.
            </p>
            <div className="pt-4 flex space-x-4" data-id="element-50">
              {/* Social placeholders */}
              <a href="#" className="p-2 bg-white/10 rounded-full hover:bg-white/20 transition-colors" data-id="element-51">
                <Instagram className="w-5 h-5" data-id="element-52" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 text-center text-white/60 text-sm" data-id="element-53">
          <p data-id="element-54">
            &copy; {new Date().getFullYear()} Coastal Ember. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}